<template>
  <div class="meta-results" data-test-id="meta-results">
    <EQueryCorrection
      v-if="queryCorrection"
      class="meta-results__result"
      :corrected="queryCorrection.corrected"
      :override="queryCorrection.override"
      :original="queryCorrection.original"
    />
    <ESpellingSuggestion
      v-if="spellingSuggestion"
      class="meta-results__result"
      :text="spellingSuggestion.text"
      :display-text="spellingSuggestion.displayText"
    />
    <EMentalHealthNotice v-if="mentalHealthVisible" />
    <EAdBlockHoneyPot v-if="adBlockShown" />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';

import EQueryCorrection from '~/components/query-correction';
import ESpellingSuggestion from '~/components/spelling-suggestion';
import EAdBlockHoneyPot from '~/components/ad-block/honey-pot';
import EMentalHealthNotice from '~~/search/web/src/components/instant-answers/mental-health/mental-health';

export const mentalHealthMarkets = ['en-gb', 'de-de', 'de-at', 'de-ch'];

export default {
  name: 'EMetaResults',
  components: {
    EQueryCorrection,
    ESpellingSuggestion,
    EAdBlockHoneyPot,
    EMentalHealthNotice,
  },
  computed: {
    ...mapState([
      'queryCorrection',
      'spellingSuggestion',
    ]),
    ...mapGetters('search', ['hasMentalHealthIntent']),
    ...mapState('user', ['bingMarketCode']),
    page() {
      return this.$route.query.p ? parseInt(this.$route.query.p, 10) : 0;
    },
    adBlockShown() {
      return this.page === 0;
    },
    mentalHealthVisible() {
      return this.hasMentalHealthIntent &&
      mentalHealthMarkets.includes(this.bingMarketCode) &&
      this.page === 0;
    },
  },
};
</script>
